import { render, staticRenderFns } from "./PresentationDetail.vue?vue&type=template&id=37c1f2b4&scoped=true&"
import script from "./PresentationDetail.vue?vue&type=script&lang=js&"
export * from "./PresentationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c1f2b4",
  null
  
)

export default component.exports